import styled from 'styled-components';
import { breakpoints } from '../../../../styles/theme';
import { StockModelPageStyled } from '../StockModelPageStyled';
import { rem } from 'polished';

export const StockModelPageStyledDS = styled(StockModelPageStyled)`
    .filter-container {
        margin-top: ${rem('20px')};
        @media (max-width: ${breakpoints.md}px) {
            padding: unset;
        }
        .filters-opened {
            @media (max-width: ${breakpoints.md}px) {
                background: ${({ theme }) => theme.colors.white};
            }
        }
    }
`;
